import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface Props {
  idLead365: string;
  DescricaoTarefa: string;
}

export function usePostAtualizarLeadTarefaConcluida() {
  const postData = async (props: Props) => {
    const POST_ATUALIZAR_LEAD = `${leadsWebEnviroment}/common/tarefas-leads/atualizar-lead-tarefa-concluida/v1`;
    const { data } = await instance.post(POST_ATUALIZAR_LEAD, {
      idLead365: props.idLead365,
      DescricaoTarefa: props.DescricaoTarefa,
    });
    return data;
  };

  const mutation = useMutation({
    mutationFn: postData,
    onSuccess: () => {
      toast.success("Lead atualizado com sucesso!");
    },
    onError: (error: any) => {
      const errorMessages = error?.response?.data?.notifications?.map(
        (item: any) => item?.message
      ) || ["Erro ao atualizar lead"];
      toast.error(errorMessages.join(", "), { autoClose: 10000 });
    },
  });

  return mutation;
}
